const STATUS_COLORS = { pending: "warning", confirmed: "success", canceled: "error", abandoned: "gray" };

export const registrationStatusBadge = (registration) => ({
  color: STATUS_COLORS[registration.status] || "gray",
  label: registration.status_label,
});
